<template>
  <span>
    <el-dialog
      :title='`"${title}" 活动地址`'
      :visible="visible"
      width="50%"
      @close="handleClose"
    >
      <el-input id="activityLink" v-model="this.activityLink"/>

      <div role="alert" class="el-alert el-alert-tip">
        <i class="el-alert__icon el-icon-info"></i>
        <div class="el-alert__content">
          <span class="el-alert__title el-alert_title">链接已复制到剪切板，粘贴到浏览器地址栏访问活动页面；</span>
        </div>
      </div>

       <div class="activity-desc">活动开始前可通过此链接预览内购活动以及活动商品，购买功能待活动开始后开启;</div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      activityLink: {
        type: String,
        required: true
      }
    },
    methods: {
      handleClose(done) {
        this.$emit('close')
      },
    },
    updated() {
      var activityLink = document.getElementById("activityLink");
      activityLink.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      // 获取选中
      var selection = window.getSelection();
      // 清除选中
      selection.removeAllRanges();
    }
  }
</script>

<style scoped>
  .el-alert-tip {
    margin: 10px 0;
    background-color: #e6f7ff;
    border: 2px solid #b5e3ff;
  }

  .el-icon-info {
    color: #1690fe;
  }

  .el-alert_title {
    color: #868d91;
    font-size: 16px;
  }

  .activity-desc {
    color: #515151;
    font-size: 16px;
  }
</style>
